<!-- Localized -->
<template>
    <div class="print-d-block flex flex-col space-y-4 overflow-y-auto px-2 overflow-x-hidden">
        <!-- {{expandedCard.sources}} -->
        <div @click="handleExpandAll" class="print-hidden text-blue-600 ml-auto cursor-pointer hover:text-blue-400 inline-flex">
            <template v-if="!adverseCard.expandedPanel">{{ $t('actions.expand_all') }}</template>
            <template v-else>{{ $t('actions.collapse_all') }}</template>
        </div>

       
        <div>
            <div v-if="screeningListData">
                <div ref="refAliases" @click="fetchMoreInfo(adverseCard, 'screening')" class="headingBlock print-d-block flex items-center py-1 px-2 bg-blue-50 mt-2 justify-between border border-solid border-blue-200 rounded cursor-pointer hover:shadow-md">
                    <div class="text-lg font-medium">{{ $t('components.tools.world_compliance.screening_list') }}</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 cursor-pointer transition-all transform duration-300 hover:text-brand" :class="{'rotate-180': adverseCard.screeningExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="p-2 headingBlock-sibling" v-show="adverseCard.screeningExpanded">
                    <div class="mt-2">
                        <div class="mb-2 flex space-x-2" :identifier="`['data']['NameSource']`">
                            <div class="w-1/3 lg:w-1/4 font-semibold text-left py-2 pr-3 text-gray-400">{{ $t('components.tools.world_compliance.source') }}</div>
                            <div class="w-full p-2">
                                <div class="flex justify-between items-center">
                                    <span class="space-y-2 mb-2 font-medium">
                                        <template> {{ adverseCard.NameSource }}</template>
                                    </span>
                                </div>
                            </div>
                        </div>
                         <div class="mb-2 flex space-x-2" :identifier="`['data']['ExpirationDate']`">
                            <div class="w-1/3 lg:w-1/4 font-semibold text-left py-2 pr-3 text-gray-400">{{ $t('components.tools.world_compliance.record_expiration_date') }}</div>
                            <div class="w-full p-2">
                                <div class="flex justify-between items-center">
                                    <span class="space-y-2 mb-2 font-medium">
                                        <template> {{ adverseCard?.ExpirationDate?.length ? adverseCard?.ExpirationDate : "-"  }}</template>
                                    </span>
                                </div>
                            </div>
                        </div>
                         <div class="mb-2 flex space-x-2" :identifier="`['data']['File']['EffectiveDate']`">
                            <div class="w-1/3 lg:w-1/4 font-semibold text-left py-2 pr-3 text-gray-400">{{ $t('components.tools.world_compliance.record_effective_date') }}</div>
                            <div class="w-full p-2">
                                <div class="flex justify-between items-center">
                                    <span class="space-y-2 mb-2">
                                        <template> {{ adverseCard?.EffectiveDate?.length ? adverseCard?.EffectiveDate : "-"  }}</template>
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="py-1 px-2 bg-gray-50 mt-4 border border-solid border-gray-200 rounded">
                    <div class="text-lg font-medium">{{ $t('components.saas.adverse_media.lexis_bridger.screening_list') }}</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.screeningExpanded"></div>
            </div>
        </div>

        <!-- Relationship section -->
        <div v-if="get(adverseCard.data, 'Relationships', []).length > 0">
            <template>
                <div
                    ref="refAliases"
                    @click="fetchMoreInfo(adverseCard, 'relationship')"
                    class="headingBlock print-d-block flex items-center py-1 px-2 bg-blue-50 mt-2 justify-between border border-solid border-blue-200 rounded cursor-pointer hover:shadow-md"
                >
                    <div class="text-lg font-medium">{{ $t('components.saas.adverse_media.lexis_bridger.relationships') }}</div>
                    <div>
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 cursor-pointer transition-all transform duration-300 hover:text-brand"
                        :class="{ 'rotate-180': adverseCard.relationshipExpanded }"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                        />
                        </svg>
                    </div>
                </div>
                <div
                class="p-2 headingBlock-sibling"
                v-show="adverseCard.relationshipExpanded"
                >
                <div class="shadow rounded border border-solid border-gray-300 overflow-x-auto">
                    <table
                    id="principals"
                    class="principalsTable w-full divide-y divide-gray-200"
                    >
                    <thead class="bg-gray-50 sticky top-0">
                        <tr>
                        <th
                            scope="col"
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                            {{ $t('components.saas.adverse_media.lexis_bridger.entity_name') }}
                        </th>
                        <th
                            scope="col"
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                            {{ $t('components.saas.adverse_media.lexis_bridger.relationship_group') }}
                        </th>
                        <th
                            scope="col"
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                            {{ $t('components.saas.adverse_media.lexis_bridger.type') }}
                        </th>
                        <th
                            scope="col"
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                            {{ $t('components.saas.adverse_media.lexis_bridger.ownership_percentage') }}
                        </th>
                        <th
                            scope="col"
                            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                            {{ $t('components.saas.adverse_media.lexis_bridger.segment') }}
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(relation,index) in adverseCard.data.Relationships" :key="index" :class="{'bg-gray-100': index % 2 === 0, 'bg-white': index % 2 !== 0}"
                        :identifier="`
                            ['data']['Relationships'][${index}]['EntityName']
                            ['data']['Relationships'][${index}]['Group'] 
                            ['data']['Relationships'][${index}]['Type'] 
                            ['data']['Relationships'][${index}]['OwnershipPercentage'] 
                            ['data']['Relationships'][${index}]['Segments'] 
                        `">
                            <td class="px-6 py-2 text-sm text-gray-500 break-words">{{relation?.EntityName}}</td>
                            <td class="px-6 py-2 text-sm text-gray-500 break-words">{{relation?.Group}}</td>
                            <td class="px-6 py-2 text-sm text-gray-500 break-words">{{relation?.Type}}</td>
                            <td class="px-6 py-2 text-sm text-gray-500 break-words">{{relation?.OwnershipPercentage}}</td>
                            <td class="px-6 py-2 text-sm text-gray-500 break-words">{{relation?.Segments}}</td>
                        </tr>

                    </tbody>
                    
                    </table>
                </div>
                </div>
            </template>
        </div>

        <!-- <div class="mb-2">
            <template v-if="get(adverseCard, 'data.EntityDetails.Addresses', []).length > 0">
                <div ref="refAddressSection" @click="fetchMoreInfo(adverseCard, 'addressesLexisBridger')" class="headingBlock flex items-center py-1 px-2 bg-blue-50 mt-4 justify-between border border-solid border-blue-200 rounded cursor-pointer hover:shadow-md">
                    <div class="text-lg font-medium">{{ $t('components.saas.adverse_media.lexis_bridger.addresses') }}</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 cursor-pointer transition-all transform duration-300 hover:text-brand" :class="{'rotate-180': adverseCard.addressesLexisBridgerExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="p-2 headingBlock-sibling" v-if="adverseCard.addressesLexisBridgerExpanded">
                    <template v-if="adverseCard.data.EntityDetails.EntityType == 'Individual' || adverseCard.data.EntityDetails.EntityType == 'Business'">
                        <div class="print-overflow-table mb-2 flex flex-col addressesDowjones">
                            <table class="min-w-full divide-y divide-gray-200 border border-solid border-gray-300 mb-2">
                                <thead class="bg-gray-50">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            {{ $t('components.saas.adverse_media.lexis_bridger.line') }}
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            {{ $t('components.saas.adverse_media.lexis_bridger.city') }}
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            {{ $t('components.saas.adverse_media.lexis_bridger.state') }}
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            {{ $t('components.saas.adverse_media.lexis_bridger.country') }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="bg-white divide-y divide-gray-200">
                                    <tr v-for="(addDet, addIndex) in getAddress(adverseCard.data.EntityDetails.Addresses)" :key="addIndex">
                                        <td class="px-6 py-3 text-left" :identifier="`['data']['Address'][${addIndex}]['Street1']`"
                                        :identifier="`
                                            ['data']['EntityDetails']['Addresses'][${addIndex}]['Street1']
                                            ['data']['EntityDetails']['Addresses'][${addIndex}]['City'] 
                                            ['data']['EntityDetails']['Addresses'][${addIndex}]['StateProvinceDistrict'] 
                                            ['data']['EntityDetails']['Addresses'][${addIndex}]['Country'] 
                                        `">
                                            {{
                                                get(addDet, "Street1", "")
                                                    .split(";")
                                                    .join(" ")
                                            }}
                                        </td>
                                        <td class="px-6 py-3 text-left">
                                            {{
                                                get(addDet, "City", "")
                                                    .split(";")
                                                    .join(" ")
                                            }}
                                        </td>
                                        <td class="px-6 py-3 text-left">
                                            {{
                                                get(addDet, "StateProvinceDistrict", "")
                                                    .split(";")
                                                    .join(" ")
                                            }}
                                        </td>
                                        <td class="px-6 py-3 text-left">
                                            {{
                                                get(addDet, "Country", "")
                                                    .split(";")
                                                    .join(" ")
                                            }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </template>
                </div>
            </template>
            <template v-else>
                <div class="py-1 px-2 bg-gray-50 mt-4 border border-solid border-gray-200 rounded">
                    <div class="text-lg font-medium">{{ $t('components.saas.adverse_media.lexis_bridger.addresses') }}</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.addressesLexisBridgerExpanded"></div>
            </template>
        </div> -->

        <!-- Additional information -->
        <div>
            <template>
                <div ref="refAliases" @click="fetchMoreInfo(adverseCard, 'otherinfo')" class="headingBlock print-d-block flex items-center py-1 px-2 bg-blue-50 mt-2 justify-between border border-solid border-blue-200 rounded cursor-pointer hover:shadow-md">
                    <div class="text-lg font-medium">{{ $t('components.saas.adverse_media.lexis_bridger.additional_information') }}</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 cursor-pointer transition-all transform duration-300 hover:text-brand" :class="{'rotate-180': adverseCard.otherinfoExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="p-2 flex-col  headingBlock-sibling" v-show="adverseCard.otherinfoExpanded">
                    <div class="mt-2">
                        <div class="mb-2 gap-3 space-x-2">
                           
                            <div class="w-full p-2">
                                <div class="grid col-2" v-for="[data, value] in Object.entries(additionalInformation)" :key="data">
                                    <div class="flex gap-2 mt-2.5" v-if="data!='Relationships'" :identifier="getAdditionalIden(data)">
                                        <span class="text-s text-gray-500 w-1/3 lg:w-1/4 "> {{ $t(`components.tools.world_compliance.${data}`) }} :</span>
                                        <span class="text-m font-medium w-full" v-if="data!='profile_notes' || !editFields"> {{value}} </span>
                                        <textarea v-else
                                            :style="{
                                                height: 'calc(100% - 0.2rem)',
                                                width: '100%',
                                                'background-color': 'white'
                                            }"
                                            class="resize-y rounded-xl px-4 py-2 border-2"
                                            rows="10"
                                            :placeholder="$t(`components.tools.world_compliance.${data}`)"
                                            v-model="getProfileNotes"
                                        >
                                        </textarea>
                                    </div>
                                    <div class="mt-2.5" v-else>
                                        <template class="flex gap-2 mt-2.5">
                                            <span class="text-s text-gray-500 w-1/3 lg:w-1/4 ">{{data}}:</span>
                                            <span class="text-m font- w-full">{{value}}</span>
                                        </template>
                                        <div class="w-full lg:h-3/4 mt-2.5" v-if="value=='Yes'">
                                            <div class="print-overflow-table flex justify-between items-center overflow-x-auto scroll INFORMATION_PROVIDER">
                                                <table class="min-w-full divide-y divide-gray-200 border border-solid border-gray-300">
                                                    <thead class="bg-gray-50" >
                                                        <tr>
                                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                {{ $t('components.tools.world_compliance.name') }}
                                                            </th>
                                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                {{ $t('components.tools.world_compliance.relation_type') }}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="bg-white divide-y divide-gray-200">
                                                        
                                                        <tr v-for="(res, ri) in adverseCard.Relations" :key="ri">
                                                        <td class="px-6 py-4 whitespace-nowrap">
                                                            <div :identifier="`['data']['Relations'][${ri}]['Name']`">
                                                            {{ getFormattedName(res.Name) }}
                                                            </div>
                                                        </td>
                                                        <td class="px-6 py-4 whitespace-nowrap">
                                                            <div :identifier="`['data']['Relations'][${ri}]['RelationDef']`">
                                                            {{ res.Type.RelationDef }}
                                                            </div>
                                                        </td>
                                                        </tr>
                                                    </tbody>
                                                    <!-- <tbody class="bg-white divide-y divide-gray-200" v-else>
                                                        <tr>
                                                            <td colspan="2" class="py-2 text-center">No data available</td>
                                                        </tr>
                                                    </tbody> -->
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <!-- Record sources --> 
        <div>
            <template v-if="sourceLinks.length > 0 || editFields">
                <div ref="refAliases" @click="fetchMoreInfo(adverseCard, 'sources')" class="headingBlock print-d-block flex items-center py-1 px-2 bg-blue-50 mt-2 justify-between border border-solid border-blue-200 rounded cursor-pointer hover:shadow-md">
                    <div class="text-lg font-medium">{{ $t('components.saas.adverse_media.lexis_bridger.record_sources') }}</div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 cursor-pointer transition-all transform duration-300 hover:text-brand" :class="{'rotate-180': adverseCard.sourcesExpanded}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                </div>
                <div class="p-2 headingBlock-sibling" v-show="adverseCard.sourcesExpanded">
                    <div class="mt-2">
                        <div class="mb-2 flex space-x-2" :identifier="`['adverseCard']['data']['EntityDetails']['AdditionalInfo']`">
                            <div class="w-full p-2">
                                <div v-if="sourceLinks.length > 0 || editFields">
                                    <template v-if="!editFields">
                                        <div class="flex justify-between items-center" v-for="dataSource in SourceWebLink" :key="dataSource">
                                            <div class="space-y-2">
                                                <div class="flex justify-between items-center"  :identifier="`['data']['SourceWebLink']`">
                                                    <span class="space-y-2 mb-2">
                                                        <a :href="dataSource" class="text-blue-600 hover:text-blue-900 no-underline" target="_blank">
                                                            <span class="break-words"> {{ dataSource }} </span>
                                                        </a>
                                                        <!-- <template><a>{{ data1 }}</a></template> -->
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    
                                    <textarea v-else
                                        :style="{
                                            height: 'calc(100% - 0.2rem)',
                                            width: '100%',
                                            'background-color': 'white'
                                        }"
                                        class="resize-y rounded-xl px-4 py-2 border-2"
                                        rows="10"
                                        :placeholder="$t('components.saas.adverse_media.lexis_bridger.record_sources')"
                                        v-model="sourceLinks"
                                    >
                                    </textarea>
                                </div>
                                <div v-else>
                                    <div class="flex justify-between items-center" v-for="(data, index) in get(adverseCard, 'data.EntityDetails.AdditionalInfo', [])" :key="index"
                                    :identifier="`['data']['EntityDetails']['AdditionalInfo'][${index}]['Comments']`">
                                        <div class="space-y-2" v-if="data.Type === 'Other' && data.Value === 'Sources of Record Information' && data.Comments">
                                            <div class="flex justify-between items-center" v-for="(data1, index) in data.Comments.split('|')" :key="index">
                                                <span class="space-y-2 mb-2">
                                                    <a :href="data1" class="text-blue-600 hover:text-blue-900 no-underline" target="_blank">
                                                        <span class="break-words"> {{ data1 }} </span>
                                                    </a>
                                                    <!-- <template><a>{{ data1 }}</a></template> -->
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="py-1 px-2 bg-gray-50 mt-4 border border-solid border-gray-200 rounded">
                    <div class="text-lg font-medium">{{ $t('components.saas.adverse_media.lexis_bridger.record_sources') }}</div>
                </div>
                <div class="headingBlock-sibling" v-if="adverseCard.sourcesExpanded"></div>
            </template>
        </div>
    </div>
</template>
<script>
// import { DateTime } from "luxon";
import {get} from "lodash";
import {DateTime} from "luxon";
import adverseMixin from "@shared/tools/mixins/adverseMixin";
import printDataMixin from "@shared/tools/mixins/printDataMixin";
import highlighterMixin from "@shared/mixins/highlighterMixin";

export default {
    components: {
    },
    data() {
        return {
            selected: "Enforcements",
            // TODO translate if will be used
            segmentsTabs: ["Enforcements", "SOE", "Adverse Media"],
            urlFields: ["related url", "locationurl"],
            isPrintLoader: false,
            refBtnClick: {
                advDetails: true,
                advAssociates: true,
                advPEP: true,
                advPepClass: true,
                advFitness: true,
                advImages: true,
                advAdverseMedia: true,
                advMediaData: true,
                refNameSection: true,
                refcontryTerritoryDetails: true,
                refDatesSection: true,
                refAddressSection: true,
                refImagesSection: true,
                refRolesSection: true,
                refRelativeCloseDowjonesSection: true,
                refProfileNotesDowjonesSection: true,
                refSourceSection: true,
                refworldcheck: true,
                refAliases: true,
                refCitizenships: true,
                refLocations: true,
                refFurtherInfo: true,
                refInformationSources: true,
            },
            printDone: false,
        };
    },
    mixins: [adverseMixin, printDataMixin, highlighterMixin],
    props: {
        expandedCard: {
            type: Object,
        },
        isResultExpanded: {
            type: Boolean,
        },
        source: {
            type: String,
        },
        isComparisonModeOn: {
            type: Boolean,
            default: false,
        },
        editFields: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        segmentsAvailable() {
            if (this.adverseCard.data?.Enforcements 
            || this.adverseCard.data?.PEPs 
            || this.adverseCard.data?.SOEs
            || this.adverseCard.data?.AdverseMedias) {
                return true
            }
            else {
                return false
            }
        },

        additionalInformation() {
            let information = {
                "parent_id": "-",
                "master_id": this.adverseCard.Ent_ID,
                "category": this.adverseCard.EntryCategory.length>0 ? this.adverseCard.EntryCategory : "-",
                "subcategory": this.adverseCard.EntrySubCategory.length>0 ? this.adverseCard.EntrySubCategory: "-",
                "pep_exposure_level": this.adverseCard.EntLevel.length>0 ? this.adverseCard.EntLevel: "-",
                "pep_negative_news": this.adverseCard?.Watch == "0"? "No": "Yes",
                "relationships": this.adverseCard.Relations.length>0 ? "Yes": "No",
                "profile_notes": this.adverseCard.Remarks.length > 0 ? this.adverseCard.Remarks : "-"
            };

            if (information["relationships"] == "Yes") {
                information["parent_id"] =  this.adverseCard.Relations[0].Ent_ID
            }

            return information
        },

        // TODO component should be reworked to translate tab names
        segmentTabs() {
            let tabs = ["Enforcements", "SOE", "Adverse Media"]
            if (this.adverseCard?.data?.PEPs) {
                tabs = ["Enforcements", "Adverse Media", "PEP"]
            }
            if (this.adverseCard?.data?.OtherSegments) {
                tabs.push("Other Segments")
            }
            if (this.adverseCard?.data?.Sanctions) {
                tabs.push("Sanction")
            }
            return tabs
        },
        isMedia() {
            return this.adverseCard?.doc.media && this.adverseCard?.doc.media.length > 0;
        },
        adverseCardKey() {
            return this.expandedCard?.key;
        },

        profileData() {
            return get(this.adverseCard, "data.EntityDetails.AKAs", []).length > 0 || get(this.adverseCard, "data.EntityDetails.AdditionalInfo", []).length || get(this.adverseCard, "data.EntityDetails.IDs", []).length || get(this.adverseCard, "data.EntityDetails.Addresses", []).length;
        },

        screeningListData() {
            return this.adverseCard.NameSource
        },

        adverseCard: {
            get() {
                return this.expandedCard?.api_all_data ?? {};
            },
            set(val) {
                this.expandedCard.api_all_data = val;
            }
        },

        getProfileNotes: {
            get() {
                return this.adverseCard?.Remarks;
            },
            set(val) {
                this.adverseCard = {
                    ...this.adverseCard,
                    Remarks: val
                };
            }
        },

        sourceLinks: {
            get() {
                return this.adverseCard?.SourceWebLink
            },
            set(val) {
                this.adverseCard = {
                    ...this.adverseCard,
                    SourceWebLink: val
                };
            }
        },

        SourceWebLink() {
            return this.adverseCard?.SourceWebLink?.split(";")
        },
    },
    watch: {},
    mounted() {    
    },
    methods: {
        get,
        getAdditionalIden(data) {
            if (data == 'Category') {
                return "['data']['EntryCategory']"
            }
            if (data == 'Subcategory') {
                return "['data']['EntrySubCategory']"
            }
            if (data == 'PEP Exposure Level') {
                return "['data']['EntLevel']"
            }
            if (data == 'PEP Negative News') {
                return "['data']['Watch']"
            }
            if (data == 'Profile Notes') {
                return "['data']['Remarks']"
            }

        },
        getFormattedName(name) {

                if (name.split(",")[1] && name.split(",")[0]) {
                return name.split(",")[1] + " " + name.split(",")[0].trim()
                }
                else if (name.split(",")[1] && !name.split(",")[0]) {
                    return name.split(",")[1]
                }
                else if (!name.split(",")[1] && name.split(",")[0]) {
                    return name.split(",")[0]
                }
            
        },
        selectedInfo(info) {
            this.selected = info;
        },
        getFormattedDate(date) {
            if (date) {
                return date.split("-").reverse().join("-")
            }
            else return ''
        },
        getIdentifierMapping(key, index, listLength) {
            let mapping = "";
            if (key === "dateDetails")
                mapping = `['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Day'] 
                ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Month'] 
                ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Year']`;
            else if (key === "countryDetails") {
                for (let i = 0; i < listLength; i++) mapping += ` ['data']['${this.source}']['CountryDetails'][${index}]['CountryValue'][${i}]['@name']`;
            } else if (key === "dates") {
                if (listLength >= 0)
                    mapping = `['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue'][${listLength}]['@Day']
                    ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue'][${listLength}]['@Month']
                    ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue'][${listLength}]['@Year']`;
                else
                    mapping = `['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Day']
                    ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Month']
                    ['data']['${this.source}']['DateDetails']['Date'][${index}]['DateValue']['@Year']`;
            } else if (key === "SanctionRefs") mapping = `['data']['${this.source}']['SanctionsReferences'][${index}]['data']['@name'] ['data']['${this.source}']['SanctionsReferences'][${index}]['Value']['#text']`;
            else if (key === "SanctionRefsSince") mapping = `['data']['${this.source}']['SanctionsReferences'][${index}]['@SinceDay'] ['data']['${this.source}']['SanctionsReferences'][${index}]['@SinceMonth'] ['data']['${this.source}']['SanctionsReferences'][${index}]['@SinceYear']`;
            else if (key === "SanctionRefsTo") mapping = `['data']['${this.source}']['SanctionsReferences'][${index}]['@ToDay'] ['data']['${this.source}']['SanctionsReferences'][${index}]['@ToMonth'] ['data']['${this.source}']['SanctionsReferences'][${index}]['@ToYear']`;
            else if (key === "OtherSegments") {
                mapping = `['data']['OtherSegments'][${index}]['Source']`;
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['OtherSegments'][${index}]['SubCategories'][${i}]`;
            } else if (key === "Enforcements") {
                mapping = `['data']['Enforcements'][${index}]['Source'] ['data']['Enforcements'][${index}]['Country'] `;
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['Enforcements'][${index}]['SubCategories'][${i}]`;
            } else if (key === "PEPs") {
                mapping = `['data']['PEPs'][${index}]['Status'] 
                            ['data']['PEPs'][${index}]['IsPrimary']
                            ['data']['PEPs'][${index}]['Country'] 
                            ['data']['PEPs'][${index}]['AdminUnit']
                            ['data']['PEPs'][${index}]['AdminLevel'] 
                            ['data']['PEPs'][${index}]['CountryRole']
                            ['data']['PEPs'][${index}]['GoverningInstitution']
                            ['data']['PEPs'][${index}]['GoverningRole'] 
                            ['data']['PEPs'][${index}]['EffectiveDate']
                            ['data']['PEPs'][${index}]['ExpirationDate']`;
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['PEPs'][${index}]['SubCategories'][${i}]`;
            } else if (key === "SOEs__SubCategories") {
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['SOEs'][${index}]['SubCategories'][${i}]`;
            } else if (key === "SOEs__Domain") {
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['SOEs'][${index}]['Domain'][${i}]`;
            } else if (key === "AdverseMedias") {
                mapping = `['data']['AdverseMedias'][${index}]['Description']`;
                for (let i = 0; i < listLength; i++) 
                    mapping += ` ['data']['AdverseMedias'][${index}]['SubCategories'][${i}]`;
            }

            return mapping;
        },

        getCategory(category) {
            if (category === "None") return "AKA";
            else return category + " AKA";
        },

        getImages(adverseCard) {
            let img_arr = [];
            let img = adverseCard.Images;
            if (img) {
                if (Array.isArray(img)) {
                    img_arr = img;
                    // return img
                } else {
                    img_arr = img.Image;
                    // return img.Image
                }
            }
            return img_arr;
        },
        get_image_url(img) {
            if (img["@URL"] !== undefined) {
                return img["@URL"];
            } else {
                return "";
            }
        },
        async printPageLexis(id, name, print, noPrint) {
            this.printDone = false;
            this.isPrintLoader = true;
            await this.handleExpandAll(true);
            if (!print) {
                let htmlPDF = await this.printData(id, name, noPrint);
                this.$emit("updatePrintStatus", "");
                this.isPrintLoader = false;
                if (noPrint) {
                    return htmlPDF;
                }
            }
        },
        getAddress(address) {
            if (address) {
                if (Array.isArray(address)) return address;
                else {
                    let obj = [address];
                    return obj;
                }
            } else return [];
        },
        getFormattedTime(ts) {
            if (ts) {
                let date = new Date(ts).toISOString();
                date = DateTime.fromISO(date);
                return date.toFormat("dd MMM yyyy");
            }
            return "-";
        },
    },
};
</script>


<style scoped>
   .tabActions {
    display: flex;
    overflow: hidden;
    overflow-x: auto;
}
/* .scroll-bar {
    height: 10px;
} */
.tabs {
    width: 100%;
    border-bottom: 3px solid var(--brand-accent-neutral);
    cursor: pointer;
    margin: 0.4rem 0;
    font-family: var(--brand-font);
    position: -webkit-sticky;
    position: sticky;
    top: 0px;
    z-index: 10;
    display: flex;
}
.tabContainer {
    width: 100%;
}

.tab {
    transform: translateY(3px);
    border-bottom: 3px solid transparent;
    transition: var(--transition-mnml);
    border-radius: var(--component-border) var(--component-border) 0 0;
    font-size: 16px;
    text-align: center;
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
::-webkit-scrollbar {
  width: 10px;
  height: 12px;
}
::-webkit-scrollbar:vertical {
     background-color: gray; /* Blue thumb */
  border-radius: 10px;
  border: 2px solid #f1f1f1; 
}

::-webkit-scrollbar-track {
  background: white;
}

::-webkit-scrollbar-thumb {
  background-color: gray; /* Blue thumb */
  border-radius: 10px;
  border: 2px solid #f1f1f1; /* Optional border to make it stand out */
}
@media print {
    .rotate-180 {
        display: none !important;
    }
    .searchIcon {
        display: none !important;
    }
}
</style>
<style>
.cascading-highlighter {
        background-color: #f6f1bb;
    }
@media print {
    .Vue-Toastification__container {
        display: none !important;
    }
    .print-hidden {
        display: none !important;
    }
    .searchIcon {
        display: none !important;
    }
    .relatives-close-associates {
        overflow-x: hidden !important;
    }
    .print-d-block {
        display: block !important;
    }
    table {
        page-break-inside: auto !important;
    }
    table tr {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    table th {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    table tr div {
        page-break-inside: avoid !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
    }
    table tr:before {
        min-height: 60px !important;
    }
    div {
        page-break-inside: auto !important;
        page-break-after: auto !important;
        page-break-before: auto !important;
        box-sizing: content-box !important;
    }
    tr {
        page-break-inside: avoid !important;
    }
    table {
        table-layout: fixed !important;
    }
    /* table, */
    thead,
    /* tbody, */
    /* tr  */
    /* td, */
    th {
        display: block !important;
    }
    table thead tr {
        top: -9999px !important;
        left: -9999px !important;
        display: none !important;
    }

    table tr:nth-child(odd) {
        background: #f6f8fc !important;
    }
    table tr {
        /* border: none !important;
        border-bottom: 1px solid #eee !important;
        position: relative !important;
        align-items: center !important;
        display: flex !important;
        white-space: normal !important;
        word-wrap: break-word !important;
        padding: 5px 15px !important; */
        width: 100%;
    }
}
</style>
